<template>
  <div>
    <div class="panel pt-1 pb-3">
      <div v-if="isResourcesLoading">
        <div class="px-5"><resources-loading-skeleton /></div>
      </div>
      <div v-else class="panel-body-lg pb-4">
        <div class="panel-header pb-2">
          <div class="pt-4 pb-1"><h2>Employee resources</h2></div>
          <div class="alert alert-error mt-3" v-if="isLoadingError">
            {{ errorMsg }}
          </div>
        </div>
        <div class="row pr-lg-5">
          <div
            v-for="(resource, i) in resources"
            :key="i"
            class="resources-wrapper col-12 col-xl-6"
          >
            <div>
              <resources-card :resource-data="resource" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import ResourcesCard from "./ResourcesCard";
import ResourcesLoadingSkeleton from "./ResourceLoadingSkeleton";

export default {
  name: "Recommendations",
  components: {
    ResourcesCard,
    ResourcesLoadingSkeleton,
  },
  mounted() {
    this.getResources();
  },
  data() {
    return {
      resources: [],
      isResourcesLoading: false,
      isLoadingError: false,
      errorMsg: CONSTANTS.SERVER_ERROR_MESSAGE
    };
  },
  methods: {
    async getResources() {
      try {
        this.isResourcesLoading = true;
        let response = await api.getRecommendationsByUserProfile();
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.quickSolutions
        ) {
          this.resources = response.data.data.quickSolutions.sort((a, b) =>
            a.title > b.title ? 1 : b.title > a.title ? -1 : 0
          );
        } else {
          this.isLoadingError = true;
        }
      } catch (error) {
        this.isLoadingError = true;
      } finally {
        this.isResourcesLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.loading-skeleton {
  min-height: 300px;
}
.resources-wrapper {
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/resources/ResourcesPanel.vue